import React, { ReactElement, useState } from 'react';
import { Box, HStack, Slider, Text, VStack } from '@chakra-ui/react';
import { getBlockValue } from 'utils/blockMigrationUtils';
import { SABlockProps } from '../SelfAssessmentBlock';

type Props = SABlockProps;

export const ReviewSABlock = ({ block }: Props): ReactElement => {
  const [score, setScore] = useState<number>(Math.max(block.props.score, block.props.minScore));

  return (
    <VStack
      border="default"
      borderColor="border.accent"
      borderRadius="l"
      p="l"
      gap="l"
      width="100%"
      alignItems="flex-start"
      contentEditable={false}
    >
      <Text textStyle="h4.medium" color="text.primary">
        {getBlockValue(block, 'question')}
      </Text>

      <HStack maxWidth="500px" width="100%" gap="15px">
        <Slider.Root
          defaultValue={[block.props.minScore]}
          min={block.props.minScore}
          max={block.props.maxScore}
          step={1}
          disabled
          colorScheme="green"
          flexGrow={1}
          value={[score]}
        >
          <Slider.Control>
            <Slider.Track height="5px" backgroundColor="border.accent">
              <Slider.Range />
            </Slider.Track>
            <Slider.Thumb
              index={0}
              boxSize="22px"
              backgroundColor="background.accent !important"
              borderRadius="100%"
              border="4px solid"
              borderColor="grey.white"
              shadow="0px 0px 0px 1px #3EA37E !important"
              _grabbed={{
                shadow: '0px 0px 0px 1px #3EA37E !important',
              }}
              _active={{
                shadow: '0px 0px 0px 1px #3EA37E !important',
              }}
            />
          </Slider.Control>
        </Slider.Root>
        <Box
          borderRadius="5px"
          backgroundColor="background.canvas"
          display="grid"
          placeItems="center"
          width="30px"
          height="25px"
          border="default"
          borderColor="border.accent"
        >
          <Text textStyle="body.m.regular" color="text.primary" lineHeight="16px">
            {score}
          </Text>
        </Box>
      </HStack>
    </VStack>
  );
};
